// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
/* eslint-disable no-unused-vars */
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  email: null,
  info: {
    status: null,
    message: '',
  }
};

const forgotPasswordReducer = createReducer(initialState, {
  [types.SUBMIT_FORGOT_PASSWORD](state, action) {
    return {
      ...state,
    };
  },
  [types.SUBMIT_FORGOT_PASSWORD_SUCCESS](state, action) {
    return {
      email: null,
      info: {
        status: true,
        message: 'Check your email. Message with your password sent!',
      }
    };
  },
  [types.SUBMIT_FORGOT_PASSWORD_FAILED](state, action) {
    return {
      ...state,
      info: {
        status: false,
        message: 'Wrong email. Try again.',
      }
    };
  },
  [types.FORGOT_PASSWORD_CHANGE_FIELD](state, payload) {
    return {
      ...Object.assign({}, state, { [payload.field]: payload.value }),
      info: {
        status: null,
        message: '',
      }
    };
  },
  [types.FORGOT_PASSWORD_RESET_FORM](state, payload) {
    return initialState;
  },
});

export default forgotPasswordReducer;
